module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAALCAYAAABPhbxiAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADFSURBVCiRdZJRjsMwCERnoh4LFOdkcU5WV3Cv2R9TeaOGH8vADA/ZxIyI6CT3ukv6ABjuPvAUmfmOiH7PR0TLzPcvDRfBIHma2VEElQfQ3P2f8QsAKhkRa20AaAAayTMzd0lXoW8kz+q87dPKwMwo6QLwRd8kXRHRFgHqPknaajT7++buneS5iidFTf+e7t7dfZDcWRNW5HJ+eorMfG+FIeljZoeZHZKuu9GyRpd08VfxTjE/Q62xm9nxehJOzFEmywoAgD+PLXsvBvV7KgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/whitewe.png
// module id = jctM
// module chunks = 63